module.exports = __webpack_public_path__ + "img/cloudwalker_package.3d39bab1.jpg";